import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import baseUrl from "../../../baseUrl";
import {CompanyDealSettlement} from "../CompanyDealSettlement/CompanyDealSettlement";
import {requester} from "../../../services/requester";

export const CompanyDealsSettlements = ({valueCompanyState}) => {
    const {year} = useParams();
    const request = requester();
    const [companyDeals, setCompanyDeals] = useState([]);

    const bullstat = Number(valueCompanyState.split(',')[2].trim());

    useEffect(() => {
        if (valueCompanyState.split(',').length === 3) {
            request.get(`${baseUrl()}/deals/${year}/company/${bullstat}`)
                .then(company_deals => {
                    let filter_company = []
                    if (company_deals.length > 0) {

                        filter_company = company_deals.filter(company => company.amount > 0);
                    }

                    setCompanyDeals(filter_company);
                })
        }

    }, [valueCompanyState])

    return (
        <>
            <h4 style={{color: "var(--app-gold)"}}>Получена земя, чрез ДЗ:</h4>
            {companyDeals.length > 0 ? <CompanyDealSettlement settlements={companyDeals} bullstat={bullstat}/> : (
                <h5 style={{color: "var(--app-danger-fg)"}}>Няма села, чрез ДЗ</h5>)}
        </>
    );
};